@if (data) {
  <div class="summary-card">
    <header class="summary-header">
      <div class="header-left">
        <!-- <span class="encounter-badge" [ngClass]="data.summary_meta?.encounter_type">
          {{ data.summary_meta?.encounter_type || 'UNK' }}
        </span> -->
        <div class="patient-title-ai">
          <div class="demographic-detail">

          <h2 class="patient-name" title="{{ data.patient_snapshot?.demographics }}">
            {{ curData?.patient_name || 'Unknown Patient' }}
          </h2>
          <span *ngIf="curData.uhId">
            {{curData?.uhId}} 
          </span>
          <div class="_wf-pb-text-block"
          *ngIf="curData.patient_age != undefined && curData.patient_gender != undefined">
          {{curData['patient_age']}} | {{curData?.patient_gender | translate | async}}
      </div> 
      <!-- <div *ngIf="curData?.encounter_id" class="visit-id-container">
       <div>Visit Id</div>
       <div style="font-weight:600">{{curData?.encounter_id}}</div>
      </div> -->
      <!-- <div  class="visit-id-container">
        <div style="font-size:14px;">Selected Visits: </div> -->
        <!-- <div style="font-weight:600 ;">{{getEncounterIds()}}</div> -->
         <!-- <ng-container *ngFor="let ele of selectedDatas">
          <div>
          <span>Encounter Id :</span>
          <span>{{ele?.encounter_id}}</span>
          <span>Visit Type:</span>
          <span>{{ele.patientType}}</span>
          @if(ele.patientType!="OP")
          {
          <span>Visit Duration : </span>
          <span>{{ele?.admission_date_time}}</span> - <span>{{ele?.dischargeDate??'-'}}</span>
          }
          @else{
            <span>Visit Date : </span>
          <span>{{ele?.g_creation_time}}</span> 
          }
          
        </div>
         </ng-container>
       </div> -->
       <div class="visit-id-container">
        <!-- <div style="font-size:14px;">
          Selected Visits:
        </div> -->
      
        <ng-container *ngFor="let ele of selectedDatas || []">
      
          <div class="visit-chip">
       <div class="visit-chip-top">
            <span class="visit-badge"
                    [ngClass]="ele.patientType">
                {{ele.patientType}}
              </span>
           
              <span class="visit-enc ml-1">
                {{ele?.encounter_id}}
              </span>

              <div class="patient-flags">
              
                @if(ele?.high_risk){
                <img src="assets/images/Critical-patient.svg" alt="High Risk" title="High Risk" class="flag-icon">
                }
              
                @if(ele?.vulnerable){
                <img src="assets/images/Vulnerable.png" alt="Vulnerable" title="Vulnerable" class="flag-icon">
                }
              
                @if(ele?.infectious){
                <img src="assets/images/Infectious.png" alt="Infectious" title="Infectious" class="flag-icon">
                }
              
                @if(ele?.prolonged_stay){
                <img src="assets/images/Prolonged_Stay.svg" alt="Prolonged Stay" title="Prolonged Stay" class="flag-icon">
                }
              
              </div>
            </div>
      
            <div class="visit-details">
      
              <ng-container *ngIf="ele.patientType!='OP'; else opVisit">
      
                <span>
                  {{formatDate(ele?.admission_date_time)}}
                </span>
      
                <span class="separator">→</span>
      
                <span>
                  {{formatDate(ele?.dischargeDate) || 'Present'}}
                </span>
              </ng-container>
              <ng-template #opVisit>
                <span>
                  {{formatDate(ele?.g_creation_time)}}
                </span>
              </ng-template>
            </div>
          </div>
        </ng-container>
      
      </div>
    </div>
          @if (data.patient_snapshot?.chief_complaint && data.patient_snapshot?.chief_complaint!='null') {
            <span class="text-muted" style="font-size: 0.8em; margin-left: 8px;display:block;margin-top:5px;max-width: max-content;">
              {{ data.patient_snapshot.chief_complaint }}
            </span>
          }
        </div>
        
      </div>
      <div class="meta-right">
        <span>{{ data.summary_meta?.specialty_service }}</span>
        @if (data.summary_meta?.visit_duration) {
          <span>• {{ data.summary_meta?.visit_duration }}</span>
        }
      </div>
    </header>
    <div class="summary-body">
      <div class="top-grid">
        <section class="card diagnosis-card interactive-card"
          [ngClass]="acuityColorClass"
          [class.expanded]="isDiagnosisExpanded"
          (click)="isDiagnosisExpanded = !isDiagnosisExpanded">
          <div class="card-header-compact">
            <span class="card-title">
              Current Status
              <span class="acuity-pill">{{ data.diagnosis_status?.acuity || 'Stable' }}</span>
            </span>
            <span class="toggle-icon">{{ isDiagnosisExpanded ? '−' : '+' }}</span>
          </div>
          <!-- <h3 class="primary-dx">{{ data.diagnosis_status?.primary_diagnosis }}</h3> -->
          @if (data.diagnosis_status?.primary_diagnosis&& !data.diagnosis_status?.secondary_issues?.length) {
            <div class="tag-cloud"
              [ngClass]="{'collapsed-cloud': !isDiagnosisExpanded}">
              <span class="dx-tag" >{{ data.diagnosis_status?.primary_diagnosis }}</span>
            </div>
          }
          @if (data.diagnosis_status?.secondary_issues?.length) {
            <div class="tag-cloud"
              [ngClass]="{'collapsed-cloud': !isDiagnosisExpanded}">
              @if (data.diagnosis_status?.primary_diagnosis)
              {
                <span class="dx-tag" >{{ data.diagnosis_status?.primary_diagnosis }}</span>
              }
              @for (issue of data.diagnosis_status.secondary_issues; track issue) {
                <span class="dx-tag">{{ issue }}</span>
              }
            </div>
          }
          @if (data.diagnosis_status?.clinical_reasoning && data.diagnosis_status?.clinical_reasoning!='null') {
            <p class="clinical-reasoning"
              [ngClass]="{'clamp-text': !isDiagnosisExpanded}">
              "{{ data.diagnosis_status.clinical_reasoning }}"
            </p>
          }
        </section>
        @if (hasCriticalFindings) {
          <section class="card critical-card interactive-card"
            [class.expanded]="isCriticalExpanded"
            (click)="isCriticalExpanded = !isCriticalExpanded">
            <div class="card-header-compact critical-header">
              <span class="card-title">⚠️ Critical Findings</span>
              <span class="toggle-icon">{{ isCriticalExpanded ? '−' : '+' }}</span>
            </div>
            <div class="critical-grid">
              @if (isValue(data.critical_findings.abnormal_vitals)) {
                <div class="c-row">
                  <span class="c-label">Vitals</span>
                  <span class="c-value highlight">{{ data.critical_findings.abnormal_vitals }}</span>
                </div>
              }
              @if (data.critical_findings.critical_labs?.length) {
                <div class="c-row">
                  <span class="c-label">Labs</span>
                  <div class="lab-cluster" [ngClass]="{'collapsed-cloud': !isCriticalExpanded}">
                    @for (lab of data.critical_findings.critical_labs; track lab) {
                      <span class="lab-pill">{{ lab }}</span>
                    }
                  </div>
                </div>
              }
              @if (isValue(data.critical_findings.imaging_highlights)) {
                <div class="c-row">
                  <span class="c-label">Img</span>
                  <span class="c-value" [ngClass]="{'clamp-text-3': !isCriticalExpanded}">
                    {{ data.critical_findings.imaging_highlights }}
                  </span>
                </div>
              }
            </div>
          </section>
        }
      </div>
      <div class="tri-col-grid">
        @if (hasTreatment) {
          <section class="card standard-card card-status">
            <h4 class="section-label">In-Facility Tx</h4>
            <div class="treatment-flex">
              @if (data.treatment_administered?.acute_medications?.length) {
                <div class="t-group">
                  <span class="sub-label">Meds</span>
                  <div class="med-pills">
                    @for (med of data.treatment_administered.acute_medications; track med) {
                      <span class="med-pill">{{ med }}</span>
                    }
                  </div>
                </div>
              }
              @if (data.treatment_administered?.drug_to_drug_interactions?.length) {
              <div class="t-group">
                <span class="sub-label">Drug-Drug</span>
                <div class="med-pills">
                  @for (interaction of data.treatment_administered.drug_to_drug_interactions; track interaction) {
                  <span class="med-pill interaction-pill">{{ interaction }}</span>
                  }
                </div>
              </div>
              }
              
              @if (data.treatment_administered?.drug_to_allergy_interactions?.length) {
              <div class="t-group">
                <span class="sub-label">Drug-Allergy</span>
                <div class="med-pills">
                  @for (interaction of data.treatment_administered.drug_to_allergy_interactions; track interaction) {
                  <span class="med-pill allergy-pill">{{ interaction }}</span>
                  }
                </div>
              </div>
              }
              @if (data.treatment_administered?.procedures_performed?.length) {
                <div class="t-group">
                  <span class="sub-label">Proc</span>
                  <span class="text-block">{{ data.treatment_administered.procedures_performed.join(', ') }}</span>
                </div>
              }
              @if (data.treatment_administered?.non_pharm_interventions) {
                <div class="t-group">
                  <span class="sub-label">Intv</span>
                  <span class="text-block clamp-text">{{ data.treatment_administered.non_pharm_interventions }}</span>
                </div>
              }
              </div>
              </section>
        }
        @if (data.discharge_plan) {
          <section class="card success-card">
            <h4 class="section-label success-label">Discharge Rx</h4>
            <div class="rx-container">
              @if (data.discharge_plan.home_medications?.length) {
                <table class="rx-table">
                  @for (rx of data.discharge_plan.home_medications; track rx) {
                    <tr>
                      <td class="rx-name">{{ rx.drug }}</td>
                      @if(rx.instruction && rx.instruction!='null')
                      {
                      <td class="rx-instr">{{ rx.instruction }}</td>
                      }
                    </tr>
                  }
                </table>
              } @else {
                <p class="empty-muted">No Discharge Data Found</p>
              }
            </div>
          </section>
        }
        @if (data.discharge_plan) {
          <section class="card info-card">
            <h4 class="section-label">Follow Up</h4>
            <div class="info-content">
              <p class="follow-up-text">{{ isValue(data.discharge_plan.follow_up) ? data.discharge_plan.follow_up : 'None' }}</p>
              @if (data.patient_snapshot?.allergies) {
                <div class="alert-box">
                  <strong>Allergies:</strong> {{ data.patient_snapshot.allergies }}
                </div>
              }

              @if (isValue(data.patient_snapshot?.birth_history)) {
              <div class="info-row">
                <strong>Birth History:</strong>
                <span>{{ data.patient_snapshot.birth_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.past_medical_history)) {
              <div class="info-row">
                <strong>Past Medical History:</strong>
                <span>{{ data.patient_snapshot.past_medical_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.past_surgical_history)) {
              <div class="info-row">
                <strong>Past Surgical History:</strong>
                <span>{{ data.patient_snapshot.past_surgical_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.obs_gynec_history)) {
              <div class="info-row">
                <strong>Obs/Gynec History:</strong>
                <span>{{ data.patient_snapshot.obs_gynec_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.family_history)) {
              <div class="info-row">
                <strong>Family History:</strong>
                <span>{{ data.patient_snapshot.family_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.social_history)) {
              <div class="info-row">
                <strong>Social History:</strong>
                <span>{{ data.patient_snapshot.social_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.sexual_history)) {
              <div class="info-row">
                <strong>Sexual History:</strong>
                <span>{{ data.patient_snapshot.sexual_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.psychosocial_assessment)) {
              <div class="info-row">
                <strong>Psychosocial Assessment:</strong>
                <span>{{ data.patient_snapshot.psychosocial_assessment }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.travel_history)) {
              <div class="info-row">
                <strong>Travel History:</strong>
                <span>{{ data.patient_snapshot.travel_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.marital_history)) {
              <div class="info-row">
                <strong>Marital History:</strong>
                <span>{{ data.patient_snapshot.marital_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.previous_fertility_history)) {
              <div class="info-row">
                <strong>Previous Fertility History:</strong>
                <span>{{ data.patient_snapshot.previous_fertility_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.immunisation_history)) {
              <div class="info-row">
                <strong>Immunisation History:</strong>
                <span>{{ data.patient_snapshot.immunisation_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.previous_investigation_history)) {
              <div class="info-row">
                <strong>Previous Investigation History:</strong>
                <span>{{ data.patient_snapshot.previous_investigation_history }}</span>
              </div>
              }
              
              @if (isValue(data.patient_snapshot?.oncology_history)) {
              <div class="info-row">
                <strong>Oncology History:</strong>
                <span>{{ data.patient_snapshot.oncology_history }}</span>
              </div>
              }
            </div>
          </section>
        }
      </div>
      @if (data.clinical_narrative) {
        <details class="narrative-details" open>
          <summary class="narrative-header">
            <span class="header-title">Clinical Narrative</span>
            <span class="expand-icon"></span>
          </summary>
          <div class="narrative-body">
            <p>{{ data.clinical_narrative }}</p>
          </div>
        </details>
      }
    </div>
  </div>
}